'use client';

import { useState, useEffect } from 'react';
import HourBlock, { HourBlockItem } from './HourBlock';

interface HourData {
  hour: string;
  items: HourBlockItem[];
}

interface ProductionScheduleInteractiveProps {
  scheduleData: HourData[];
}

export default function ProductionScheduleInteractive({
  scheduleData: initialData,
}: ProductionScheduleInteractiveProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [scheduleData, setScheduleData] = useState(initialData);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleToggleComplete = (hour: string, itemId: string) => {
    setScheduleData((prevData) =>
      prevData.map((hourBlock) =>
        hourBlock.hour === hour
          ? {
              ...hourBlock,
              items: hourBlock.items.map((item) =>
                item.id === itemId ? { ...item, completed: !item.completed } : item
              ),
            }
          : hourBlock
      )
    );
  };

  if (!isHydrated) {
    return (
      <div className="w-full overflow-x-auto no-scrollbar">
        <div className="flex gap-6 pb-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="min-w-[320px] h-96 bg-accent rounded-2xl animate-pulse"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-auto no-scrollbar">
      <div className="flex gap-6 pb-4 snap-x snap-mandatory">
        {scheduleData.map((hourBlock) => (
          <HourBlock
            key={hourBlock.hour}
            hour={hourBlock.hour}
            items={hourBlock.items}
            onToggleComplete={(itemId) => handleToggleComplete(hourBlock.hour, itemId)}
          />
        ))}
      </div>
    </div>
  );
}